import { render, staticRenderFns } from "./score_edit_pc.vue?vue&type=template&id=b0be43d4&scoped=true&"
import script from "./score_edit_pc.vue?vue&type=script&lang=js&"
export * from "./score_edit_pc.vue?vue&type=script&lang=js&"
import style0 from "./score_edit_pc.vue?vue&type=style&index=0&id=b0be43d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0be43d4",
  null
  
)

export default component.exports